import { styled } from 'linaria/react';
import { css } from 'linaria';

export const MainProductContainer = styled.div`
  display: flex;
  align-items: center;
  gap: var(--space-400);
  width: 100%;
  padding-left: var(--space-450);

  @media (--only-mobile) {
    flex-direction: column;
    gap: var(--space-200);
    padding-left: var(--space-500);
  }
`;

export const MainProductImageAndName = styled.div`
  display: flex;
  gap: var(--space-300);
  width: 100%;
  @media (--only-mobile) {
    gap: var(--space-200);
  }
`;
export const CounterAndSelectTintColorContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: var(--space-100);
  width: 100%;

  @media (--only-mobile) {
    flex-direction: column-reverse;
    align-items: flex-start;
    width: 100%;
  }
`;

export const PriceColumnContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: var(--space-75);
  margin-left: auto;
  white-space: nowrap;

  @media (--only-mobile) {
    order: 1;
    margin-left: 0px;

    & > div {
      justify-content: flex-start;
    }
  }
`;

export const MainProductName = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-100);
  max-width: 225px;
  @media (--only-mobile) {
    max-width: 100%;
  }
`;

export const MainProductInfoRow = styled.div`
  display: flex;
  @media (--only-mobile) {
    flex-direction: column;
    gap: var(--space-100);
  }
`;

export const MainProductInfo = styled.div`
  display: flex;
  align-items: baseline;
  gap: var(--space-100);
`;

export const MainProductInfoColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-200);
  width: 100%;
`;

export const ItemLink = css`
  cursor: 'pointer';
`;

export const ProductImgWithLink = styled.img`
  cursor: pointer;
`;
